import React, { useState, useEffect, useMemo, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  getRecentlyAddedProgramsTopicActionHandler,
  postImageActionHandler,
  addTopicActionHandler,
  getTopicDetailsByProgramIDActionHandler,
  updateTopicActionHandler,
  searchProgramActionHandler,
  searchProgramForNewTopicActionHandler,
} from "../../../../../store/actions/actionHandlers/organizeActionHandler";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "../../../../../components/Common/ToolTip/Tooltip";
import InfoIcon from "../../../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import Button from "../../../../../components/Common/Button/Button";
import Input from "../../../../../components/Common/Input/Input";
import NextIcon from "../../../../../components/Common/SvgIcons/CommonIcons/NextIcon";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { addNewTopic } from "../../../../../utils/mainTabs/organize/addNewTopic";
import classes from "./NewTopicContent.module.scss";
import InfiniteScrollComponent from "../../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import {
  setProgramDataAction,
  setShotClassDataAction,
} from "../../../../../store/actions/actionCreators/organizeActionCreator";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import CrossIcon from "../../../../../components/Common/SvgIcons/SocialIcons/CrossIcon";
import Modal from "../../../../../components/Common/Modal/Modal";
import TopicCourseAssociationsModal from "./TopicCourseAssociationsModal/TopicCourseAssociationsModal";
import { topicManagement } from "../../../../../utils/mainTabs/organize/topicManagement";
import useHashArray from "../../../../../hooks/useHashArray";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Loader from "../../../../../components/Common/Loader/Loader";
import { contentMediaTypes } from "../../../../../utils/contentMediaTypes";
import { FormattedMessage } from "react-intl";

export const topicContentSchema = yup.object().shape({
  UserGroupDetails: yup
    .array(
      yup.object().shape({
        Training: yup.string(),
      })
    )
    .min(1, "Training is required!"),
});

const NewTopicContent = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const routerParams = useParams();
  const pageSize = 8;
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [searchText, setSearchText] = useState("");
  const [getAllTopics, setGetAllTopics] = useState([]);
  const [selectedTopicData, setSelectedTopicData] = useState([]);
  const [selectedTopicIds, setSelectedTopicIds] = useState([]);
  const [imageUrl, setImageUrl] = useState("");

  const [selectedShotClassIds, setSelectedShotClassIds] = useState([]);
  const [selectedProgramIds, setSelectedProgramIds] = useState([]);

  const [selectedTrainingIds, setselectedTrainingIds] = useState([]);
  const [movedTopicData, setMovedTopicData] = useState([]);
  const [movedTopicDataByCross, setmovedTopicDataByCross] = useState([]);

  const [selectedTpc, setSelectedTpc] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);

  const [classTypeData, setClassTypeData] = useState([]);
  const [activeData, setActiveData] = useState(false);
  const [checkBoxCheckedClass, setcheckBoxCheckedClass] = useState(true);
  const [checkBoxCheckedProgram, setcheckBoxCheckedProgram] = useState(false);

  const [topicCourseAssociations, setTopicCourseAssociations] = useState([]);
  const [hidePopUp, setHidePopUp] = useState(false);
  const [topicCourseHeading, setTopicCourseHeading] = useState();
  const [loader, setLoader] = useState(true);
  const [activeLoader, setActiveLoader] = useState(false);
  const [callApi, setCallApi] = useState(true);
  const [publishedLoader, setPublishedLoader] = useState(false);
  const [saveTopicLoader, setSaveTopicLoader] = useState(false);
  const organizeState = useSelector((state) => state.organizeReducer);
  const { shotClassData, programData } = organizeState;
  const {
    formData,
    setFormData,
    shotClassCount,
    programCount,
    pathType,
    dataForUpdateTopicByID,
    tenantName,
  } = useOutletContext();
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(topicContentSchema),
    defaultValues: useMemo(() => {
      return {
        ...formData?.details,
        ...formData?.topicContent,
      };
    }, [formData?.details, formData?.topicContent]),
  });
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    setValue,
  } = methods;
  useEffect(() => {
    reset(() => formData);
  }, [formData]);
  useEffect(() => {
    if (formData?.details?.thumbnailImageFile.length == "1") {
      // const formImgData = new FormData();
      // formImgData.append("file", formData?.details?.thumbnailImageFile?.[0]);
      dispatch(
        postImageActionHandler(
          formData?.details?.thumbnailImageFile,
          setImageUrl
        )
      ).then((response) => {
        if (response) {
          setLoader(false);
        }
      });
    }
  }, [dispatch, formData?.details?.thumbnailImageFile]);
  const [pageNumTrueForProgram, setPageNumTrueForProgram] = useState(true);
  const [pageNumTrueForShotclass, setPageNumTrueForShotclass] = useState(true);
  useEffect(() => {
    if (pageNum > 1) {
      dispatch(
        getRecentlyAddedProgramsTopicActionHandler(
          "WithoutVTLT",
          "Published",
          activeData ? "Program" : "ShotClass",
          "none",
          true,
          "none",
          pageNum,
          pageSize
        )
      );
    }
  }, [pageNum]);
  useEffect(() => {
    setClassTypeData(activeData ? programData : shotClassData);
  }, [
    shotClassData,
    programData,
    activeData,
    setClassTypeData,
    classTypeData,
    setSelectedTpc,
  ]);
  const [checkSearchTxt, setCheckSearchTxt] = useState(true);
  const fetchMoreData = () => {
    if (activeData && classTypeData?.length >= shotClassCount) {
      setHasMoreData(false);
      return;
    }
    if (!activeData && classTypeData?.length >= programCount) {
      setHasMoreData(false);
      return;
    }
    if (checkSearchTxt) {
      setPageNum((prevState) => prevState + 1);
    }
  };
  // console.log(
  //   "shotClassCount",
  //   shotClassCount,
  //   "programCount------",
  //   programCount,

  //   "classTypeData",
  //   classTypeData
  // );
  const [topicCourseAss, setTopicCourseAss] = useState();
  const { hashTable: topicCourseAssList } = useHashArray(
    topicCourseAss,
    "Value",
    true
  );
  const [topicCourseAssIDs, setTopicCourseAssIDs] = useState();
  const { hashTable: topicCourseAssListIDs } = useHashArray(
    topicCourseAssIDs,
    "Value",
    true
  );
  const { hashTable: selectedTopicItemsList } = useHashArray(
    selectedTpc,
    "ID",
    true
  );

  useEffect(() => {
    // if (location?.pathname?.includes(addNewTopic?.editpath(tenantName))) {
    //   setTopicCourseAss(formData?.topicContent?.TopicCourseAssociations);
    // }
    if (formData?.topicContent?.TopicCourseAssociations)
      setTopicCourseAss(formData?.topicContent?.TopicCourseAssociations);
  }, [
    location.pathname,
    formData,
    formData?.topicContent?.TopicCourseAssociations,
  ]);
  useEffect(() => {
    if (pathType === "edit") {
      setTopicCourseAssIDs(formData?.topicContent?.TopicCourseAssociations);
    }
  }, [setTopicCourseAssIDs]);
  const handleTopics = (e, data, index) => {
    if (e.target.checked === true) {
      // debugger;
      //selectedTopicData.push(data);
      if (!selectedTopicData.find((item) => item.ID === data.ID)) {
        selectedTopicData.push(data);
      }
      selectedTopicIds.push(data.ID);
      // if (pathType === "edit") {
      //   topicCourseAssIDs.map((item) => {
      //     if (
      //       item?.Type === "ShotClass" &&
      //       selectedShotClassIds.indexOf(item?.Value) === -1
      //     ) {
      //       selectedShotClassIds.push(item?.Value);
      //     } else if (
      //       item?.Type === "Program" &&
      //       selectedProgramIds.indexOf(item?.Value) === -1
      //     ) {
      //       selectedProgramIds.push(item?.Value);
      //     }
      //   });
      // }

      if (data.Type == "ShotClass") {
        selectedShotClassIds.push(data?.ID);
        let selectedShotClassUniqueIds = [
          ...new Set(selectedShotClassIds.map((item) => item)),
        ];
        setSelectedShotClassIds(selectedShotClassUniqueIds);
      } else {
        selectedProgramIds.push(data?.ID);
        let selectedProgramUniqueIds = [
          ...new Set(selectedProgramIds.map((item) => item)),
        ];
        setSelectedProgramIds(selectedProgramUniqueIds);
      }
      const updatedData = classTypeData?.map((item) => {
        if (
          (activeData ? item?.Programs?.ID : item?.ShotClass?.ID) === data?.ID
        ) {
          return { ...item, isChecked: true, disabled: false };
        } else return item;
      });
      if (activeData) {
        dispatch(setProgramDataAction(updatedData));
      } else {
        dispatch(setShotClassDataAction(updatedData));
      }
    } else {
      const updatedArr = selectedTopicData.filter(
        (dataVal) => dataVal.ID !== data.ID
      );
      setSelectedTopicData(updatedArr);
      const updateSelectedTopicIDs = selectedTopicIds.filter(
        (dataValID) => dataValID !== data.ID
      );
      setSelectedTopicIds(updateSelectedTopicIDs);
      const updatedData = classTypeData?.map((item) => {
        if (
          (activeData ? item?.Programs.ID : item?.ShotClass?.ID) === data?.ID
        ) {
          return { ...item, isChecked: false, disabled: false };
        } else return item;
      });
      if (activeData) {
        dispatch(setProgramDataAction(updatedData));
      } else {
        dispatch(setShotClassDataAction(updatedData));
      }
    }
  };
  // useEffect(() => {
  //   if (selectedTpc.length > 1) {
  //     let selectedShotClassUniqueIds = [
  //       ...new Set(selectedShotClassIds.map((item) => item)),
  //     ];
  //     setSelectedShotClassIds(selectedShotClassUniqueIds);
  //     let selectedProgramUniqueIds = [
  //       ...new Set(selectedProgramIds.map((item) => item)),
  //     ];
  //     setSelectedProgramIds(selectedProgramUniqueIds);
  //   }
  // }, [selectedTpc]);

  const [movedTopicDataID, setMovedTopicDataID] = useState([]);
  const handleTrainingContent = (e, data) => {
    if (e.target.checked === true) {
      movedTopicData.push(data?.ID || data?.Value);
      let movedTopicDataID = [...new Set(movedTopicData.map((item) => item))];
      setMovedTopicDataID(movedTopicDataID);
      // if (pathType === "edit") {
      //   movedTopicData.push(data?.Value);
      // } else {
      //   movedTopicData.push(data?.ID);
      // }
    } else {
      if (pathType === "edit") {
        const updatedArr = movedTopicDataID.filter(
          (dataVal) => dataVal !== data.Value
        );
        setMovedTopicData(updatedArr);
      } else {
        const updatedArr = movedTopicDataID.filter(
          (dataVal) => dataVal !== data.ID
        );
        setMovedTopicData(updatedArr);
      }
    }
  };

  const handlePrevBtn = () => {
    if (pathType === "edit") {
      const updatedArr = classTypeData?.map((data) => {
        if (
          movedTopicDataID.includes(
            activeData ? data?.Programs?.ID : data?.ShotClass?.ID
          )
        ) {
          return { ...data, isChecked: false, disabled: false };
        } else return data;
      });
      if (activeData) {
        dispatch(setProgramDataAction(updatedArr));
      } else {
        dispatch(setShotClassDataAction(updatedArr));
      }
    } else {
      const updatedArr = classTypeData?.map((data) => {
        if (
          movedTopicDataID.includes(
            activeData ? data?.Programs?.ID : data?.ShotClass?.ID
          )
        ) {
          return { ...data, isChecked: false, disabled: false };
        } else return data;
      });
      if (activeData) {
        dispatch(setProgramDataAction(updatedArr));
      } else {
        dispatch(setShotClassDataAction(updatedArr));
      }
    }

    // if (pathType === "edit") {
    //   const updateRightData = selectedTpc?.filter(
    //     (dataVal) => !movedTopicData.includes(dataVal?.Value || dataVal?.ID)
    //   );
    //   setSelectedTpc(updateRightData);
    //   const updateEditSelectedData = topicCourseAss.filter(
    //     (data) => !movedTopicData.includes(data?.Value || data?.ID)
    //   );
    //   setTopicCourseAss(updateEditSelectedData);
    // } else {
    //   const updateRightData = selectedTpc.filter(
    //     (dataVal) => !movedTopicData.includes(dataVal?.ID || dataVal?.Value)
    //   );
    //   setSelectedTpc(updateRightData);
    // }
    const updateEditSelectedData = topicCourseAss?.filter(
      (data) => !movedTopicDataID.includes(data?.Value || data?.ID)
    );
    setTopicCourseAss(updateEditSelectedData);

    const updateRightData = selectedTpc?.filter(
      (dataVal) => !movedTopicDataID.includes(dataVal?.ID || dataVal?.Value)
    );
    setSelectedTpc(updateRightData);
    setMovedTopicData([]);
  };

  const handleClassType = (msg) => {
    if (msg == 1) {
      setActiveLoader(true);
      // reset();
      setPageNum(1);
      setHasMoreData(true);
      // setPageNumTrueForProgram(false);
      // setPageNumTrueForShotclass(true);
      dispatch(
        getRecentlyAddedProgramsTopicActionHandler(
          "WithoutVTLT",
          "Published",
          "ShotClass",
          "none",
          true,
          "none",
          1,
          pageSize,
          pageNumTrueForShotclass
        )
      ).then((response) => {
        // debugger;
        const updatedData = response.data.map((item) => {
          if (
            selectedTopicItemsList[item?.ShotClass?.ID] ||
            topicCourseAssList[item?.ShotClass?.ID]
          ) {
            return {
              ...item,
              isChecked: true,
              disabled: true,
            };
          } else {
            return { ...item, isChecked: false, disabled: false };
          }
        });
        dispatch(setShotClassDataAction(updatedData));
        setActiveLoader(false);
      });
      setActiveData(false);
      setcheckBoxCheckedProgram(false);
      setcheckBoxCheckedClass(true);
      setClassTypeData([]);
      setClassTypeData(shotClassData);
      if (classTypeData?.[0]?.Program !== null) {
        const updatedData = selectedTpc?.map((item) => {
          if (selectedShotClassIds.includes(item?.ID || item?.Value)) {
            return { ...item, disabled: false };
          } else return { ...item, disabled: true };
        });
        setSelectedTpc(updatedData);
        // setElementsSelectedTopic(updatedData);
      }
    } else {
      setHasMoreData(true);
      setActiveLoader(true);
      // setPageNumTrueForProgram(true);
      // setPageNumTrueForShotclass(false);
      // reset();
      setPageNum(1);
      dispatch(
        getRecentlyAddedProgramsTopicActionHandler(
          "WithoutVTLT",
          "Published",
          "Program",
          "none",
          true,
          "none",
          1,
          pageSize,
          pageNumTrueForProgram
        )
      ).then((response) => {
        const updatedData = response.data.map((item) => {
          if (
            selectedTopicItemsList[item?.Programs?.ID] ||
            topicCourseAssList[item?.Programs?.ID]
          ) {
            return {
              ...item,
              isChecked: true,
              disabled: true,
            };
          } else {
            return { ...item, isChecked: false, disabled: false };
          }
        });
        dispatch(setProgramDataAction(updatedData));
        setActiveLoader(false);
      });
      setActiveData(true);
      setClassTypeData([]);
      setClassTypeData(programData);
      setcheckBoxCheckedClass(false);
      setcheckBoxCheckedProgram(true);
      if (classTypeData?.[0]?.ShotClass !== null) {
        const updatedData = selectedTpc?.map((item) => {
          if (selectedProgramIds.includes(item?.ID || item?.Value)) {
            return { ...item, disabled: false };
          } else return { ...item, disabled: true };
        });
        setSelectedTpc(updatedData);
        // setElementsSelectedTopic(updatedData);
        // dispatch(setProgramDataAction(updatedData));
      }
    }
  };
  const handleNextBtn = () => {
    const updatedData = classTypeData?.map((item) => {
      if (item?.isChecked) {
        return { ...item, disabled: true };
      } else return item;
    });
    if (activeData) {
      dispatch(setProgramDataAction(updatedData));
    } else {
      dispatch(setShotClassDataAction(updatedData));
    }
    setSelectedTpc((prev) => [...prev, ...selectedTopicData]);
    //setTopicCourseAss((prev) => [...prev, ...selectedTopicData]);
    // if (pathType === "edit") {
    // }
    setTopicCourseAss((prev) => [...prev, ...selectedTopicData]);
    setSelectedTopicData([]);
  };
  const handleCrossIcon = (data) => {
    // movedTopicDataByCross.push(data?.ID);
    movedTopicDataByCross.push(data?.Value || data?.ID);
    const updatedArr = classTypeData.map((data) => {
      if (
        movedTopicDataByCross.includes(
          activeData ? data?.Programs?.ID : data?.ShotClass?.ID
        )
      ) {
        return { ...data, isChecked: false, disabled: false };
      } else return data;
    });
    if (activeData) {
      dispatch(setProgramDataAction(updatedArr));
    } else {
      dispatch(setShotClassDataAction(updatedArr));
    }
    const updatedTopics = selectedTpc.filter(
      (dataVal) => (dataVal?.ID || dataVal?.Value) !== (data?.ID || data?.Value)
    );
    setSelectedTpc(updatedTopics);
    setTopicCourseAss(updatedTopics);
  };

  const handleModal = (data, heading) => {
    setHidePopUp(true);
    setTopicCourseHeading(heading);
    dispatch(
      getTopicDetailsByProgramIDActionHandler(data, setTopicCourseAssociations)
    );
  };
  // const [filterText, setFilterText] = useState("");
  // const handleSearchBtn = useCallback(
  //   (e) => {
  //     let val = e.target.value.trim() !== "" && e.target.value;
  //     setFilterText(val);
  //     console.log(filterText);
  //     if (val) {
  //       dispatch(
  //         getRecentlyAddedProgramsTopicActionHandler(
  //           "WithoutVTLT",
  //           "Published",
  //           "Program",
  //           val,
  //           true,
  //           "none",
  //           1,
  //           pageSize
  //         )
  //       );
  //     } else {
  //       setFilterText([]);
  //     }
  //   },
  //   [dispatch]
  // );

  const onSubmit = (data, e) => {
    setPublishedLoader(true);
    e.preventDefault();
    let tagsName = formData.details.TagsList.map((item) => {
      return item?.TagName.toString();
    });
    let topicCourseAssociateonEdit = elementsSelectedTopic.map((item) => {
      return { Type: item?.Type, Value: item?.Value ? item?.Value : item?.ID };
    });
    if (pathType === "edit") {
      var updateProgramCount = 0;
      var updateShotClassCount = 0;
      elementsSelectedTopic?.forEach((item) => {
        if (item.Type === "Program")
          updateProgramCount = updateProgramCount + 1;
        else if (item.Type === "ShotClass") {
          updateShotClassCount = updateShotClassCount + 1;
        }
      });
      let updatedPostData = {
        CreatedBy: dataForUpdateTopicByID?.CreatedBy,
        CreatedOn: dataForUpdateTopicByID?.CreatedOn,
        Description: formData.details.description,
        FirstName: null,
        // ImageUrl: formData?.details?.ThumbnailImage?.ThumbnailUri
        //   ? formData?.details?.ThumbnailImage?.ThumbnailUri
        //   : dataForUpdateTopicByID?.ImageUrl,
        ImageUrl: imageUrl,
        IsCreatedByme: dataForUpdateTopicByID?.IsCreatedByme,
        IsMarkedFavourite: dataForUpdateTopicByID?.IsMarkedFavourite,
        IsPublished: dataForUpdateTopicByID?.IsPublished ? "false" : "true",
        IsTopicUpdated: dataForUpdateTopicByID?.IsTopicUpdated,
        LastName: dataForUpdateTopicByID?.LastName,
        Locale: dataForUpdateTopicByID?.Locale,
        MiddleName: dataForUpdateTopicByID?.MiddleName,
        ModifiedBy: dataForUpdateTopicByID?.ModifiedBy,
        ModifiedOn: dataForUpdateTopicByID?.ModifiedOn,
        Name: formData.details.name,
        ProgramCount: updateProgramCount,
        ShotclassCount: updateShotClassCount,
        SubTopics: dataForUpdateTopicByID?.SubTopics,
        Tags: tagsName.toString(),
        TenantId: dataForUpdateTopicByID?.TenantId,
        TopicCompletionDate: dataForUpdateTopicByID?.TopicCompletionDate,
        TopicCourseAssociations: topicCourseAssociateonEdit,
        TopicCourses: dataForUpdateTopicByID?.TopicCourses,
        TopicId: dataForUpdateTopicByID?.TopicId,
        UserTopicStatus: dataForUpdateTopicByID?.UserTopicStatus,
        ValidUpto: dataForUpdateTopicByID?.ValidUpto,
      };
      dispatch(updateTopicActionHandler(updatedPostData)).then((response) => {
        if (response.status === 200) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Subtopic ${
                dataForUpdateTopicByID?.IsPublished
                  ? " UnPublished "
                  : " Published"
              } successfully`
            )
          );
          setPublishedLoader(false);
          navigate(
            `${addNewTopic.path(
              location,
              routerParams,
              tenantName
            )}/publishNewTopic`
          );
          // dispatch(setProgramDataAction([]));
          // dispatch(setShotClassDataAction([]));
        }
      });
    } else {
      let topicCourseAssociate = selectedTpc.map((item) => {
        return { Type: item?.Type, Value: item?.ID };
      });
      setFormData((formData) => {
        return {
          ...formData,
          details: {
            ...formData.details,
            thumbnailImageFile: imageUrl,
            TagList: tagsName.toString(),
          },
          topicContent: {
            ...formData.topicContent,
            TopicCourseAssociations: topicCourseAssociate,
          },
        };
      });
      let postData = {
        Description: formData.details.description,
        ImageUrl: imageUrl,
        IsPublished: data.publishbtn ? true : false,
        Name: formData.details.name,
        Tags: tagsName.toString(),
        TopicCourseAssociations: topicCourseAssociate,
        TopicId: 0,
      };
      dispatch(addTopicActionHandler(postData)).then((response) => {
        if (response.status === 200) {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Subtopic created successfully")
          );
          setPublishedLoader(false);
          navigate(
            `${addNewTopic.path(
              location,
              routerParams,
              tenantName
            )}/publishNewTopic`
          );
          // dispatch(setProgramDataAction([]));
          // dispatch(setShotClassDataAction([]));
        }
      });
    }
  };
  const saveTopic = () => {
    setSaveTopicLoader(true);
    let tagsName = formData.details.TagsList.map((item) => {
      return item?.TagName.toString();
    });
    let topicCourseAssociateonEdit = elementsSelectedTopic.map((item) => {
      return { Type: item?.Type, Value: item?.Value ? item?.Value : item?.ID };
    });
    if (pathType === "edit") {
      var updateProgramCount = 0;
      var updateShotClassCount = 0;
      elementsSelectedTopic.forEach((item) => {
        if (item.Type === "Program")
          updateProgramCount = updateProgramCount + 1;
        else if (item.Type === "ShotClass") {
          updateShotClassCount = updateShotClassCount + 1;
        }
      });
      let updatedPostData = {
        CreatedBy: dataForUpdateTopicByID?.CreatedBy,
        CreatedOn: dataForUpdateTopicByID?.CreatedOn,
        Description: formData.details.description,
        FirstName: null,
        // ImageUrl: formData?.details?.ThumbnailImage?.ThumbnailUri
        //   ? formData?.details?.ThumbnailImage?.ThumbnailUri
        //   : dataForUpdateTopicByID?.ImageUrl,
        ImageUrl: imageUrl,
        IsCreatedByme: dataForUpdateTopicByID?.IsCreatedByme,
        IsMarkedFavourite: dataForUpdateTopicByID?.IsMarkedFavourite,
        IsPublished: dataForUpdateTopicByID?.IsPublished,
        IsTopicUpdated: dataForUpdateTopicByID?.IsTopicUpdated,
        LastName: dataForUpdateTopicByID?.LastName,
        Locale: dataForUpdateTopicByID?.Locale,
        MiddleName: dataForUpdateTopicByID?.MiddleName,
        ModifiedBy: dataForUpdateTopicByID?.ModifiedBy,
        ModifiedOn: dataForUpdateTopicByID?.ModifiedOn,
        Name: formData.details.name,
        ProgramCount: updateProgramCount,
        ShotclassCount: updateShotClassCount,
        SubTopics: dataForUpdateTopicByID?.SubTopics,
        Tags: tagsName.toString(),
        TenantId: dataForUpdateTopicByID?.TenantId,
        TopicCompletionDate: dataForUpdateTopicByID?.TopicCompletionDate,
        TopicCourseAssociations: topicCourseAssociateonEdit,
        TopicCourses: dataForUpdateTopicByID?.TopicCourses,
        TopicId: dataForUpdateTopicByID?.TopicId,
        UserTopicStatus: dataForUpdateTopicByID?.UserTopicStatus,
        ValidUpto: dataForUpdateTopicByID?.ValidUpto,
      };
      dispatch(updateTopicActionHandler(updatedPostData)).then((response) => {
        if (response.status === 200) {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Subtopic updated successfully")
          );
          setSaveTopicLoader(false);
          navigate(`${topicManagement.path(tenantName)}`);
          // dispatch(setProgramDataAction([]));
          // dispatch(setShotClassDataAction([]));
        }
      });
    } else {
      let topicCourseAssociate = selectedTpc.map((item) => {
        return { Type: item?.Type, Value: item?.ID };
      });
      setFormData((formData) => {
        return {
          ...formData,
          details: {
            ...formData.details,
            thumbnailImageFile: imageUrl,
            TagList: tagsName.toString(),
          },
          topicContent: {
            ...formData.topicContent,
            TopicCourseAssociations: topicCourseAssociate,
          },
        };
      });
      let postData = {
        Description: formData.details.description,
        ImageUrl: imageUrl,
        IsPublished: false,
        Name: formData.details.name,
        Tags: tagsName.toString(),
        TopicCourseAssociations: topicCourseAssociate,
        TopicId: 0,
      };
      dispatch(addTopicActionHandler(postData)).then((response) => {
        if (response.status === 200) {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Subtopic created successfully")
          );
          setSaveTopicLoader(false);
          navigate(`${topicManagement.path(tenantName)}`);
          // dispatch(setProgramDataAction([]));
          // dispatch(setShotClassDataAction([]));
        }
      });
    }
  };

  const handleCancelBtn = () => {
    // if (location.pathname !== addNewTopic.editpath(tenantName)) {
    const updatedData = classTypeData?.map((item) => {
      if (item?.isChecked) {
        return { ...item, isChecked: true, disabled: true };
      } else {
        return item;
      }
    });
    setFormData((formData) => {
      return {
        ...formData,
        selectedTpc: [elementsSelectedTopic],
        topicContent: {
          ...formData.topicContent,
          TopicCourseAssociations: elementsSelectedTopic,
        },
      };
    });
    if (activeData) {
      dispatch(setProgramDataAction(updatedData));
    } else {
      dispatch(setShotClassDataAction(updatedData));
    }
    // }
    dispatch(setShotClassDataAction([]));
    // debugger;
    // setCallApi(false);
  };
  useEffect(() => {
    if (shotClassData?.length === 0 && callApi) {
      // debugger;
      dispatch(
        getRecentlyAddedProgramsTopicActionHandler(
          "WithoutVTLT",
          "Published",
          "ShotClass",
          "none",
          true,
          "none",
          1,
          pageSize,
          false
        )
      );
    }
  }, [shotClassData?.length, callApi]);
  const isEmptyObj = (obj) => {
    if (obj === undefined) return true;
    else if (obj === null) return true;
    else return Object.keys(obj).length === 0;
  };
  useEffect(() => {
    if (
      (location?.pathname?.includes(addNewTopic.editpath(tenantName)) &&
        topicCourseAssList) ||
      (addNewTopic.path(location, routerParams, tenantName) &&
        topicCourseAssList)
    ) {
      const updatedData = classTypeData?.map((item) => {
        if (
          topicCourseAssList[
            activeData ? item?.Programs?.ID : item?.ShotClass?.ID
          ] ||
          (!isEmptyObj(selectedTopicItemsList) &&
            selectedTopicItemsList[
              activeData ? item?.Programs?.ID : item?.ShotClass?.ID
            ])
        ) {
          return {
            ...item,
            isChecked: true,
            disabled: true,
          };
        } else {
          return { ...item, isChecked: false, disabled: false };
        }
      });
      if (activeData) {
        dispatch(setProgramDataAction(updatedData));
      } else {
        dispatch(setShotClassDataAction(updatedData));
      }
      let arr = [];
      updatedData?.forEach((item) => {
        if (item.isChecked === true && item.disabled === true) {
          arr.push(item?.ShotClass || item?.Programs);
        }
      });
      // console.log(arr)
      const updatedSelectedTpcDisableInputChkProgramID = [];
      const updatedSelectedTpcDisableInputChkShotClassID = [];
      topicCourseAss?.forEach((item) => {
        if (item?.Type === "Program") {
          updatedSelectedTpcDisableInputChkProgramID.push(
            item?.Value || item?.ID
          );
        } else {
          updatedSelectedTpcDisableInputChkShotClassID.push(
            item?.Value || item?.ID
          );
        }
      });
      if (activeData) {
        if (classTypeData?.[0]?.Program !== null) {
          const updatedData = topicCourseAss?.map((item) => {
            if (
              updatedSelectedTpcDisableInputChkProgramID.includes(
                item?.Value || item?.ID
              )
            ) {
              return { ...item, disabled: false };
            } else return { ...item, disabled: true };
          });
          //setTopicCourseAss(updatedData);
          setSelectedTpc(updatedData);
        }
      } else {
        if (classTypeData?.[0]?.ShotClass !== null) {
          const updatedData = topicCourseAss?.map((item) => {
            if (
              updatedSelectedTpcDisableInputChkShotClassID.includes(
                item?.Value || item?.ID
              )
            ) {
              return { ...item, disabled: false };
            } else return { ...item, disabled: true };
          });
          //setTopicCourseAss(updatedData);
          setSelectedTpc(updatedData);
        }
      }

      // const updateSelectedTpc = topicCourseAss.map((item) => {
      //   debugger;
      // });
      // console.log(updateSelectedTpc);
      // setSelectedTpc(selectedTpc);
    }
    // else if (
    //   addNewTopic.path(location, routerParams, tenantName) &&
    //   topicCourseAssList
    //   //&& !isEmptyObj(selectedTopicItemsList)
    // ) {
    //   debugger;
    //   const updatedData = classTypeData?.map((item) => {
    //     // if (
    //     //   topicCourseAssListIDs[
    //     //     activeData ? item?.Programs?.ID : item?.ShotClass?.ID
    //     //   ] ||
    //     //   selectedTopicItemsList[
    //     //     activeData ? item?.Programs?.ID : item?.ShotClass?.ID
    //     //   ]
    //     // )
    //     if (
    //       topicCourseAssList[
    //         activeData ? item?.Programs?.ID : item?.ShotClass?.ID
    //       ] ||
    //       (!isEmptyObj(selectedTopicItemsList) &&
    //         selectedTopicItemsList[
    //           activeData ? item?.Programs?.ID : item?.ShotClass?.ID
    //         ])
    //     ) {
    //       return {
    //         ...item,
    //         isChecked: true,
    //         disabled: true,
    //       };
    //     } else {
    //       return { ...item, isChecked: false, disabled: false };
    //     }
    //   });
    //   if (activeData) {
    //     dispatch(setProgramDataAction(updatedData));
    //   } else {
    //     dispatch(setShotClassDataAction(updatedData));
    //   }
    //   const updatedSelectedTpcDisableInputChkProgramID = [];
    //   const updatedSelectedTpcDisableInputChkShotClassID = [];
    //   topicCourseAss?.forEach((item) => {
    //     if (item?.Type === "Program") {
    //       updatedSelectedTpcDisableInputChkProgramID.push(
    //         item?.Value || item?.ID
    //       );
    //     } else {
    //       updatedSelectedTpcDisableInputChkShotClassID.push(
    //         item?.Value || item?.ID
    //       );
    //     }
    //   });
    //   if (activeData) {
    //     if (classTypeData?.[0]?.Program !== null) {
    //       const updatedData = topicCourseAss?.map((item) => {
    //         if (
    //           updatedSelectedTpcDisableInputChkProgramID.includes(
    //             item?.Value || item?.ID
    //           )
    //         ) {
    //           return { ...item, disabled: false };
    //         } else return { ...item, disabled: true };
    //       });
    //       //setTopicCourseAss(updatedData);
    //       setSelectedTpc(updatedData);
    //     }
    //   } else {
    //     if (classTypeData?.[0]?.ShotClass !== null) {
    //       const updatedData = topicCourseAss?.map((item) => {
    //         if (
    //           updatedSelectedTpcDisableInputChkShotClassID.includes(
    //             item?.Value || item?.ID
    //           )
    //         ) {
    //           return { ...item, disabled: false };
    //         } else return { ...item, disabled: true };
    //       });
    //       //setTopicCourseAss(updatedData);
    //       setSelectedTpc(updatedData);
    //     }
    //   }
    // }
  }, [
    dispatch,
    location?.pathname,
    topicCourseAssList,
    activeData,
    topicCourseAss,
    classTypeData?.length,
    // topicCourseAssListIDs,
    // selectedTopicItemsList
    //setSelectedTpc,
    //selectedTopicItemsList
    // setSeriesShotclassDataAction,
  ]);

  const [elementsSelectedTopic, setElementsSelectedTopic] =
    useState(selectedTpc);
  useEffect(() => {
    setElementsSelectedTopic(selectedTpc);
  }, [selectedTpc]);

  const handleonDrag = (results) => {
    const { source, destination } = results;
    if (!destination) {
      return;
    }
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }
    const reorderedStores = [...elementsSelectedTopic];
    const sourceIndex = source.index;
    const destinationIndex = destination.index;
    const [removedElement] = reorderedStores.splice(sourceIndex, 1);
    reorderedStores.splice(destinationIndex, 0, removedElement);
    return [
      setElementsSelectedTopic(reorderedStores),
      setSelectedTpc(reorderedStores),
      setTopicCourseAss(reorderedStores),
    ];
  };
  console.log("elementsSelectedTopic", elementsSelectedTopic);
  console.log("selectedTpc", selectedTpc);
  const handleSearch = useCallback(
    (e) => {
      setCallApi(false);
      let searchTxtValue = e.target.value.trim() !== "" && e.target.value;
      setActiveLoader(true);
      if (activeData) {
        dispatch(setProgramDataAction([]));
      } else {
        dispatch(setShotClassDataAction([]));
      }
      if (searchTxtValue) {
        setPageNum(1);
        setCheckSearchTxt(false);
        dispatch(
          searchProgramForNewTopicActionHandler(
            searchTxtValue,
            "Published",
            "en-GB",
            activeData ? "Program" : "ShotClass",
            searchTxtValue
          )
        ).then((response) => {
          if (response) {
            const updatedData = response.map((item) => {
              if (
                selectedTopicItemsList[
                  item?.ShotClass?.ID || item?.Programs?.ID
                ] ||
                topicCourseAssList[item?.ShotClass?.ID || item?.Programs?.ID]
              ) {
                return {
                  ...item,
                  isChecked: true,
                  disabled: true,
                };
              } else {
                return { ...item, isChecked: false, disabled: false };
              }
            });
            // debugger;
            if (response.length > 0) {
              if (activeData) {
                dispatch(setProgramDataAction(updatedData));
              } else {
                dispatch(setShotClassDataAction(updatedData));
              }
            }
            setActiveLoader(false);
          }
        });
      } else {
        setActiveLoader(true);
        setPageNum(1);
        setCheckSearchTxt(true);
        dispatch(
          getRecentlyAddedProgramsTopicActionHandler(
            "WithoutVTLT",
            "Published",
            activeData ? "Program" : "ShotClass",
            "none",
            true,
            "none",
            pageNum,
            pageSize
          )
        ).then((response) => {
          const updatedData = response.data.map((item) => {
            if (selectedTopicItemsList[item?.ShotClass?.ID]) {
              return {
                ...item,
                isChecked: true,
                disabled: true,
              };
            } else {
              return { ...item, isChecked: false, disabled: false };
            }
          });
          if (activeData) {
            dispatch(setProgramDataAction(updatedData));
          } else {
            dispatch(setShotClassDataAction(updatedData));
          }
          setActiveLoader(false);
        });
      }
    },
    [activeData, selectedTopicItemsList, classTypeData, selectedTpc]
  );
  // useEffect(() => {
  //   if (topicCourseAssList !== null) {
  //     if (Object.keys(topicCourseAssList)) {
  //       // debugger;
  //       const updatedData = classTypeData?.map((item) => {
  //         if (
  //           topicCourseAssList[item?.ShotClass?.ID] ||
  //           topicCourseAssList[item?.Programs?.ID]
  //         ) {
  //           return {
  //             ...item,
  //             isChecked: true,
  //             disabled: true,
  //           };
  //         } else {
  //           return { ...item };
  //         }
  //       });
  //       if (activeData) {
  //         dispatch(setProgramDataAction(updatedData));
  //       } else {
  //         dispatch(setShotClassDataAction(updatedData));
  //       }
  //     }
  //   }

  //   if (selectedTopicItemsList !== null) {
  //     if (Object.keys(selectedTopicItemsList)) {
  //       // debugger;
  //       const updatedData = classTypeData.map((item) => {
  //         if (
  //           selectedTopicItemsList[item?.ShotClass?.ID] ||
  //           selectedTopicItemsList[item?.Programs?.ID]
  //         ) {
  //           return {
  //             ...item,
  //             isChecked: true,
  //             disabled: true,
  //           };
  //         } else {
  //           return { ...item };
  //         }
  //       });
  //       if (activeData) {
  //         dispatch(setProgramDataAction(updatedData));
  //       } else {
  //         dispatch(setShotClassDataAction(updatedData));
  //       }
  //     }
  //   }
  // }, [
  //   dispatch,
  //   topicCourseAssList,
  //   selectedTopicItemsList,
  //   classTypeData?.length,
  // ]);
  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  };
  return formData?.details?.thumbnailImageFile.length == "1" && loader ? (
    <Loader page />
  ) : (
    <div className={classes.topicContentMain}>
      <FormProvider {...methods}>
        {/* <h1 className={classes.title}>Select topic content to create group</h1> */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.topicFormsMain}>
            <div className={classes.topicContentFormsMain}>
              <div className={classes.availableTopics}>
                <div className={classes.availableTopicsTitle}>
                  {/* Available Shotclasses */}
                  Available
                  {/* <div className={classes.infoIcon}>
                <Tooltip
                  direction="right"
                  content="Available topics to make group topic"
                >
                  <InfoIcon />
                </Tooltip>
              </div> */}
                </div>
                <div className={classes.topicSearchInput}>
                  <div className={classes.classByTypeRadioBtns}>
                    <span onChange={() => handleClassType("1")}>
                      <input
                        type="radio"
                        name="classType"
                        value={"1"}
                        checked={checkBoxCheckedClass}
                      />
                      <FormattedMessage id="NEW_SHOTCLASS_TEXT" />
                    </span>
                    <span onChange={() => handleClassType("2")}>
                      <input
                        type="radio"
                        name="classType"
                        value={"2"}
                        checked={checkBoxCheckedProgram}
                      />
                      <FormattedMessage id="PROGRAM_TEXT" />
                    </span>
                  </div>
                </div>
                {/* <div className={classes.classByTypeRadioBtns}> */}
                <div className={classes.searchInputDiv}>
                  <Input
                    label={""}
                    name="tagname"
                    placeholder={"Search Tag or Name"}
                    search
                    width="auto"
                    onChange={handleSearch}
                    onKeyDown={handleKeyDown}
                    // style={{
                    //   padding: "0.6rem 13.5rem 0.6rem 3.7rem",
                    //   minHeight: "5rem",
                    //   borderRadius: "0.8rem",
                    // }}
                  />
                </div>
                {/* </div> */}
                <div className={classes.topicsList}>
                  {activeLoader ? (
                    <div className={classes.loader}>
                      <Loader height="50" width="50" />
                    </div>
                  ) : shotClassData?.length == "0" && callApi ? (
                    <div className={classes.loader}>
                      <Loader height="50" width="50" />
                    </div>
                  ) : classTypeData?.length > 0 ? (
                    <InfiniteScrollComponent
                      dataLength={
                        classTypeData?.length ? classTypeData.length : pageSize
                      }
                      fetchMoreData={fetchMoreData}
                      hasMoreData={hasMoreData}
                      height={classTypeData?.length > 0 ? "28vh" : "20vh"}
                      // loader={checkSearchTxt ? true : false}
                      loader={false}
                    >
                      <ul>
                        {classTypeData?.map((item, index) => (
                          <li
                            key={
                              activeData
                                ? item?.Programs?.ID
                                : item?.ShotClass?.ID
                            }
                          >
                            <input
                              type="checkbox"
                              name={
                                activeData
                                  ? item?.Programs?.ID
                                  : item?.ShotClass?.ID
                              }
                              value={
                                activeData
                                  ? item?.Programs?.Name
                                  : item?.ShotClass?.Name
                              }
                              width="20px"
                              height="2"
                              id={
                                activeData
                                  ? item?.Program?.ID
                                  : item?.ShotClass?.ID
                              }
                              onChange={(e) => {
                                handleTopics(
                                  e,
                                  activeData ? item?.Programs : item.ShotClass,
                                  index
                                );
                              }}
                              disabled={item?.disabled}
                              checked={item?.isChecked}
                            />
                            <label htmlFor={item?.ShotClass?.ID}>
                              {activeData
                                ? item?.Programs?.Name
                                : item?.ShotClass?.Name}
                              {activeData &&
                              item?.Programs?.ProgramTopicMappingCount > 0 ? (
                                <span
                                  onClick={() =>
                                    handleModal(
                                      item?.Programs?.ID,
                                      item?.Programs?.Name
                                    )
                                  }
                                >
                                  <InfoIcon
                                    fill={colors.theme}
                                    width={22}
                                    height={22}
                                  />
                                </span>
                              ) : (
                                <></>
                              )}
                            </label>
                            {!activeData && (
                              <div className={classes.mediaTypes}>
                                {
                                  // item?.Programs?.Mediatype ||
                                  // item?.ShotClass?.Mediatype === 0 ? (
                                  //   "Quiz and Survey"
                                  // ) :
                                  item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 1 ? (
                                    "Video"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 2 ? (
                                    "YouTube"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 3 ? (
                                    "PPT"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 4 ? (
                                    "O365Video"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 5 ? (
                                    "SlideShare"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 6 ? (
                                    "OneDrive"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 7 ? (
                                    "PDF"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 8 ? (
                                    "MOOC"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 9 ? (
                                    "SCORM"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 10 ? (
                                    "Image"
                                  ) : item?.Programs?.Mediatype ||
                                    item?.ShotClass?.Mediatype === 11 ? (
                                    "HTML5"
                                  ) : item?.ShotClass?.ShotClassType === 5 ? (
                                    "Quiz and Survey"
                                  ) : item?.ShotClass?.ShotClassType === 6 ? (
                                    "Quiz"
                                  ) : item?.ShotClass?.ShotClassType === 7 ? (
                                    "Survey"
                                  ) : (
                                    <></>
                                  )
                                }
                              </div>
                            )}
                          </li>
                        ))}
                      </ul>
                    </InfiniteScrollComponent>
                  ) : (
                    <div className={classes.noDataFound}>
                      {!activeData ? "No Classes Found" : "No Series Found"}
                    </div>
                  )}
                </div>
              </div>
              <div className={classes.nextPrvBtns}>
                <span
                  className={classes.nextBtn}
                  onClick={handleNextBtn}
                  disabled={selectedTopicData?.length > 0 ? false : true}
                >
                  <NextIcon fill={"#707070"} />
                </span>
                <span
                  className={classes.prevBtn}
                  onClick={handlePrevBtn}
                  disabled={selectedTpc?.length > 0 ? false : true}
                >
                  <NextIcon fill={"#707070"} />
                </span>
              </div>
              <div className={classes.availableTopics}>
                <div className={classes.availableTopicsTitle}>
                  {/* <FormattedMessage id="SELECTED_CLASSES" /> */}
                  Selected
                </div>
                <div className={`${classes.topicsList} ${classes.selectedTopicsList}`}>
                  <DragDropContext onDragEnd={handleonDrag}>
                    <Droppable
                      droppableId="selectedTopics"
                      key="selectedTopics"
                      type="selectedTpcTypeBox"
                    >
                      {(provided, snapshot) => {
                        return (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                              background: snapshot.isDraggingOver
                                ? "#f3f3f3"
                                : "",
                            }}
                          >
                            <ul>
                              {elementsSelectedTopic?.map((item, index) => {
                                return (
                                  <Draggable
                                    key={`SwappingList[${index}]`}
                                    draggableId={`selectedTopic-${index}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => {
                                      return (
                                        <div
                                          key={item?.ID}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={{
                                            backgroundColor: snapshot.isDragging
                                              ? "#dddddd"
                                              : "",
                                            ...provided.draggableProps.style,
                                          }}
                                        >
                                          <li key={item?.ID}>
                                            <input
                                              type="checkbox"
                                              name="Training"
                                              value={item?.Name}
                                              width="20px"
                                              height="2"
                                              id={item?.ID}
                                              onChange={(e) => {
                                                handleTrainingContent(e, item);
                                                setValue(
                                                  "training",
                                                  selectedTpc
                                                );
                                              }}
                                              disabled={item?.disabled}
                                              style={{
                                                cursor:
                                                  item?.disabled &&
                                                  "not-allowed",
                                              }}
                                              error={errors?.training?.message}
                                            />
                                            <label htmlFor={item?.ID}>
                                              {item?.Name}
                                            </label>
                                            <div className={classes.typeCross}>
                                              {item?.Type == "ShotClass" ? (
                                                <FormattedMessage id="SELECT_EVENTS" />
                                              ) : (
                                                <FormattedMessage id="PROGRAM_TEXT" />
                                              )}
                                              <span
                                                onClick={() =>
                                                  handleCrossIcon(item)
                                                }
                                                style={{
                                                  cursor:
                                                    item?.disabled &&
                                                    "not-allowed",
                                                  pointerEvents:
                                                    item?.disabled && "none",
                                                }}
                                              >
                                                <CrossIcon
                                                  fill={colors.theme}
                                                />
                                              </span>
                                            </div>
                                          </li>
                                        </div>
                                      );
                                    }}
                                  </Draggable>
                                );
                              })}
                            </ul>
                            {provided.placeholder}
                          </div>
                        );
                      }}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>

            <div className={classes.topicBtns}>
              {/* {selectedTpc.length == 0 && ( */}
              <div
                className={classes.clearAll}
                onClick={() => {
                  navigate(
                    `${addNewTopic.path(
                      location,
                      routerParams,
                      tenantName
                    )}/details`
                  );
                  handleCancelBtn();
                }}
              >
                {/* <FormattedMessage id="USERGRP_CANCELBTN_TEXT" /> */}
                <FormattedMessage id="PAGINATION_PREVIOUS" />
              </div>
              {/* )} */}
              {/* {selectedTpc.length > 0 && (
            <div className={classes.clearAll} onClick={clearAll}>
              <FormattedMessage id="CLEAR_ALL_TXT" />
            </div>
          )} */}
              <Button
                label={<FormattedMessage id="SAVE_TXT" />}
                small
                dark
                onClick={saveTopic}
                disabled={selectedTpc?.length > 0 ? false : true}
                loading={saveTopicLoader}
              />
              <Button
                label={
                  dataForUpdateTopicByID?.IsPublished ? (
                    "UnPublish"
                  ) : (
                    <FormattedMessage id="CREATE_PUBLISH_TEXT" />
                  )
                }
                small
                dark
                type={"submit"}
                disabled={!isValid || selectedTpc?.length > 0 ? false : true}
                onClick={setValue("publishbtn", true)}
                loading={publishedLoader}
              />
            </div>
          </div>
        </form>
      </FormProvider>
      {hidePopUp && (
        <Modal
          isOpen={topicCourseAssociations}
          width={"90"}
          toggle={() => setHidePopUp(false)}
          heading={topicCourseHeading}
        >
          <TopicCourseAssociationsModal
            topicCourseData={topicCourseAssociations}
          />
        </Modal>
      )}
    </div>
  );
};

export default NewTopicContent;
